import type { IMapSpotTile } from '@/features/map/map-data-v5/map-types';

import React from 'react';

import MapTileWrapper from '@/features/map/map-components/map-tiles/map-tile-wrapper';
import { MapSpotTileTopLivePricesDesktop } from '@/features/map/map-components/map-tiles/spot-tile-desktop/map-spot-tile-top-live-prices/map-spot-tile-top-live-prices-desktop';
import SeasonCalendar from '@/features/season-calendar/season-calendar';
import { trackSpotResultClick } from '@/features/spot-results/spot-result-tracking';
import SpotScoreBadge from '@/features/spot-score/spot-score-badge';

type MapSpotTileProps = IMapSpotTile;

export default function MapSpotTileDesktop({
    activity,
    activitySpotName,
    calendar,
    destinationTitle,
    iconUrl,
    image,
    linkUrl,
    spotName,
    spotScore,
    spotTitle,
    topLivePrices,
}: MapSpotTileProps) {
    return (
        <div
            className={'flex h-full'}
            data-qa-id={'qa-map-spot-tile-desktop'}
        >
            <MapTileWrapper
                cursorStyle={'pointer'}
                hasTopLivePrices={topLivePrices.length > 0}
                height={'100%'}
                iconUrl={iconUrl}
                image={image}
                isDesktopView={true}
                linkType={'internal'}
                linkUrl={linkUrl}
                onTileLinkClick={() =>
                    trackSpotResultClick({ activity, activitySpot: activitySpotName, city: spotName, isMap: true })
                }
                subtitle={destinationTitle}
                title={spotTitle}
                titleTruncation={'line-clamp-1'}
            >
                <div className={'flex flex-col pb-15 pl-15'}>
                    <SpotScoreBadge
                        fontSizeScore={'text-14'}
                        fontSizeText={'text-14'}
                        height={32}
                        marginBottom={10}
                        scoreMarginRight={'mr-10'}
                        spotScore={{
                            htmlScoreDescription: spotScore.htmlScoreDescription,
                            scoreText: spotScore.scoreText,
                        }}
                        width={32}
                    />
                    <div className={'flex flex-col gap-5'}>
                        <SeasonCalendar
                            gapOverride={3}
                            rowCount={2}
                            seasonCalendar={calendar.seasonCalendar}
                            title={calendar.title}
                            titleFontSize={'text-14'}
                            titleLineHeight={'leading-17'}
                            titleMarginBottom={5}
                            titleTruncation={'text-nowrap'}
                        />
                    </div>
                </div>
            </MapTileWrapper>

            {topLivePrices.length > 0 && (
                <div
                    className={'flex grow'}
                    style={{
                        // eslint-disable-next-line no-inline-styles/no-inline-styles
                        alignItems: 'stretch',
                        // eslint-disable-next-line no-inline-styles/no-inline-styles
                        minWidth: '85px',
                    }}
                >
                    <MapSpotTileTopLivePricesDesktop
                        activity={activity}
                        activitySpotName={activitySpotName}
                        livePrices={topLivePrices}
                        spotName={spotName}
                    />
                </div>
            )}
        </div>
    );
}
